
export function generatePath(path) {
    return (window.clientRoot || '') + path;
}

export function generateUrl(path) {
    return window.location.origin + (window.clientRoot || '') + path;
}
